<div class="container">
  <div class="content">
    <header>
      <h1><a routerLink="/home" class="titulo">F1nal Lap</a></h1>
      <img
        src="https://www.formula1.com/etc/designs/fom-website/images/f1_logo.svg"
        alt="Fórmula 1 Logo"
      />
    </header>

    <div id="progress-container" [style.z-index]="overlayState.isOpen() ? 950 : null">
      <nav appCloseOtherMenus appScrollShadow [class.nav-open]="mobileNavOpen()">
        <button
          type="button"
          class="nav-toggle"
          [attr.aria-expanded]="mobileNavOpen()"
          aria-label="Abrir menú de navegación"
          (click)="toggleMobileNav()"
        >
          <span class="nav-toggle-bar"></span>
          <span class="nav-toggle-bar"></span>
          <span class="nav-toggle-bar"></span>
        </button>

        <a
          mat-button
          routerLink="/home"
          routerLinkActive="active-link"
          [routerLinkActiveOptions]="{ exact: true }"
          >Inicio</a
        >

        <button mat-button [matMenuTriggerFor]="Informacion" #triggerTemp="matMenuTrigger">
          Formula 1 <span class="nav-chevron">▾</span>
        </button>
        <mat-menu #Informacion="matMenu">
          <a mat-menu-item routerLink="/actual" routerLinkActive="active-link">Temporada Actual</a>
          <a mat-menu-item routerLink="/last" routerLinkActive="active-link"
            >Temporadas Anteriores</a
          >
          <a mat-menu-item routerLink="/memorable" routerLinkActive="active-link"
            >Temporadas Memorables</a
          >
        </mat-menu>

        <button mat-button [matMenuTriggerFor]="Clasificacion" #triggerClas="matMenuTrigger">
          Clasificación <span class="nav-chevron">▾</span>
        </button>
        <mat-menu #Clasificacion="matMenu">
          <button mat-menu-item [routerLink]="['/ranking']" [queryParams]="{ view: 'drivers' }">
            Pilotos
          </button>
          <button mat-menu-item [routerLink]="['/ranking']" [queryParams]="{ view: 'teams' }">
            Equipos
          </button>
          <button mat-menu-item [routerLink]="['/ranking']" [queryParams]="{ view: 'races' }">
            Carreras
          </button>
        </mat-menu>

        <a mat-button routerLink="/comparar" routerLinkActive="active-link">Análisis</a>
        <a mat-button routerLink="/circuits" routerLinkActive="active-link">Simulador</a>
      </nav>

      <div id="progress-bar" appScrollProgress></div>
    </div>

    <router-outlet></router-outlet>
  </div>

  <footer>
    <a href="https://www.linkedin.com/in/aalbeerto/" target="_blank"
      >© AGA. Todos los derechos reservados.</a
    >
  </footer>
</div>
